var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tab"},[_c('li',{class:{ 'active': this.$route.name === 'follow-page-followers'}},[_c('router-link',{attrs:{"to":{ 
      name: 'follow-page-followers',
      params: { id: this.$route.params.id },
      }}},[_vm._v(" 追隨者 ")])],1),_c('li',{class:{ 'active': this.$route.name === 'follow-page-following'}},[_c('router-link',{attrs:{"to":{ 
      name: 'follow-page-following',
      params: { id: this.$route.params.id },
      }}},[_vm._v(" 正在追蹤 ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }